import React from "react";
import "./Home.css";

function Home() {
  return (
    <div id="home-div">
      <p className="p one-second-animation" id="hi-there">
        Hi there! I'm
      </p>
      <h1 className="h1 three-second-animation">Ishaan Sharma</h1>
      <h2 className="h2 five-second-animation">I'm a Software Engineer</h2>
      <p className="p seven-second-animation" id="intro">
        I have experience in Laravel, Node, React and more.
      </p>
      <p className="nine-second-animation">
        This website was created using React.js and custom CSS.
      </p>
      <a
        href={`mailto:ishaansharma1998@gmail.com`}
        className="ten-second-animation"
      >
        <button className="buttons" id="get-in-touch">
          Get in touch
        </button>
      </a>
    </div>
  );
}

export default Home;
